import React from 'react';
import { ItemDivider } from 'components/MenuList';
export default function ComboBoxMenuItemDivider() {
  return /*#__PURE__*/React.createElement(ItemDivider, {
    as: "li"
  });
}